import { PolicyDataErrorRecord } from "entities/UIModel/PolicyDataErrorRecord";

export const SAMPLE_EXCEPTION_RECORDS: PolicyDataErrorRecord[] = [
  {
    uniqueIdentifier: "EX-001-e0",
    policyErrorTypeName: "Premium Validation",
    policyErrorExceptionMessage: "Calculated premium does not match filed rate for TX residential owner policy.",
    policyErrorStatusTypeCode: "OPEN",
    policyErrorExceptionDate: "2026-03-18T10:31:00Z",
    policyNumber: "O-9840-0012345",
    fileNumber: "FN-2026-0001",
    agentID: "54321",
    stateCode: "TX",
    originationSource: "EPR",
    countyCode: "201",
    policyYear: 2026,
    policyMonth: 3,
    policyDay: 15,
    productTypeAbbrTypeCode: "O",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "",
    recordTypeName: "",
    propertyTypeCode: "R",
    propertyTypeName: "",
    batchNumber: "B-2026-0301",
    liabilityAmount: 425000,
    actualFee: 2847.50,
    actualRetention: 1423.75,
    actualRiskRate: 1423.75,
  },
  {
    uniqueIdentifier: "EX-002-e0",
    policyErrorTypeName: "Liability Range",
    policyErrorExceptionMessage: "Liability amount exceeds maximum threshold for loan policy type.",
    policyErrorStatusTypeCode: "OPEN",
    policyErrorExceptionDate: "2026-03-19T09:15:00Z",
    policyNumber: "M-9840-0012399",
    fileNumber: "FN-2026-0002",
    agentID: "54321",
    stateCode: "TX",
    originationSource: "EPR",
    countyCode: "113",
    policyYear: 2026,
    policyMonth: 3,
    policyDay: 18,
    productTypeAbbrTypeCode: "M",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "",
    recordTypeName: "",
    propertyTypeCode: "R",
    propertyTypeName: "",
    batchNumber: "B-2026-0301",
    liabilityAmount: 2500000,
    actualFee: 4250.00,
    actualRetention: 2125.00,
    actualRiskRate: 2125.00,
  },
  {
    uniqueIdentifier: "EX-002-e1",
    policyErrorTypeName: "Premium Validation",
    policyErrorExceptionMessage: "Premium amount is zero for non-void transaction.",
    policyErrorStatusTypeCode: "OPEN",
    policyErrorExceptionDate: "2026-03-19T09:15:00Z",
    policyNumber: "M-9840-0012399",
    fileNumber: "FN-2026-0002",
    agentID: "54321",
    stateCode: "TX",
    originationSource: "EPR",
    countyCode: "113",
    policyYear: 2026,
    policyMonth: 3,
    policyDay: 18,
    productTypeAbbrTypeCode: "M",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "",
    recordTypeName: "",
    propertyTypeCode: "R",
    propertyTypeName: "",
    batchNumber: "B-2026-0301",
    liabilityAmount: 2500000,
    actualFee: 4250.00,
    actualRetention: 2125.00,
    actualRiskRate: 2125.00,
  },
  {
    uniqueIdentifier: "EX-003-e0",
    policyErrorTypeName: "Agent Validation",
    policyErrorExceptionMessage: "Agent ID not found in active agent registry.",
    policyErrorStatusTypeCode: "OPEN",
    policyErrorExceptionDate: "2026-03-20T14:22:00Z",
    policyNumber: "O-7620-0098765",
    fileNumber: "FN-2026-0003",
    agentID: "99887",
    stateCode: "CA",
    originationSource: "BATCH",
    countyCode: "037",
    policyYear: 2026,
    policyMonth: 3,
    policyDay: 20,
    productTypeAbbrTypeCode: "O",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "",
    recordTypeName: "",
    propertyTypeCode: "C",
    propertyTypeName: "",
    batchNumber: "B-2026-0315",
    liabilityAmount: 1200000,
    actualFee: 5100.00,
    actualRetention: 2550.00,
    actualRiskRate: 2550.00,
  },
  {
    uniqueIdentifier: "EX-004-e0",
    policyErrorTypeName: "Date Validation",
    policyErrorExceptionMessage: "Policy date is in the future. Policy date must be on or before the current date.",
    policyErrorStatusTypeCode: "OPEN",
    policyErrorExceptionDate: "2026-03-21T08:45:00Z",
    policyNumber: "E-5510-0045678",
    fileNumber: "FN-2026-0004",
    agentID: "12345",
    stateCode: "FL",
    originationSource: "EPR",
    countyCode: "086",
    policyYear: 2026,
    policyMonth: 4,
    policyDay: 15,
    productTypeAbbrTypeCode: "E",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "",
    recordTypeName: "",
    propertyTypeCode: "R",
    propertyTypeName: "",
    batchNumber: "B-2026-0320",
    liabilityAmount: 350000,
    actualFee: 275.00,
    actualRetention: 137.50,
    actualRiskRate: 137.50,
  },
  {
    uniqueIdentifier: "EX-005-e0",
    policyErrorTypeName: "State Code Validation",
    policyErrorExceptionMessage: "State code does not match agent's licensed states.",
    policyErrorStatusTypeCode: "OPEN",
    policyErrorExceptionDate: "2026-03-22T11:30:00Z",
    policyNumber: "C-3320-0011223",
    fileNumber: "FN-2026-0005",
    agentID: "67890",
    stateCode: "NY",
    originationSource: "EPR",
    countyCode: "061",
    policyYear: 2026,
    policyMonth: 3,
    policyDay: 22,
    productTypeAbbrTypeCode: "C",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "",
    recordTypeName: "",
    propertyTypeCode: "R",
    propertyTypeName: "",
    batchNumber: "B-2026-0322",
    liabilityAmount: 875000,
    actualFee: 3250.00,
    actualRetention: 1625.00,
    actualRiskRate: 1625.00,
  },
  {
    uniqueIdentifier: "EX-006-e0",
    policyErrorTypeName: "Premium Validation",
    policyErrorExceptionMessage: "Retention amount exceeds premium amount.",
    policyErrorStatusTypeCode: "RESOLVED",
    policyErrorExceptionDate: "2026-03-10T16:00:00Z",
    policyNumber: "O-4410-0056789",
    fileNumber: "FN-2026-0006",
    agentID: "54321",
    stateCode: "TX",
    originationSource: "BATCH",
    countyCode: "201",
    policyYear: 2026,
    policyMonth: 3,
    policyDay: 8,
    productTypeAbbrTypeCode: "O",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "",
    recordTypeName: "",
    propertyTypeCode: "R",
    propertyTypeName: "",
    batchNumber: "B-2026-0308",
    liabilityAmount: 310000,
    actualFee: 1875.00,
    actualRetention: 937.50,
    actualRiskRate: 937.50,
  },
  {
    uniqueIdentifier: "EX-007-e0",
    policyErrorTypeName: "Liability Range",
    policyErrorExceptionMessage: "Liability amount is zero for non-endorsement policy.",
    policyErrorStatusTypeCode: "RESOLVED",
    policyErrorExceptionDate: "2026-03-12T13:20:00Z",
    policyNumber: "M-8810-0034567",
    fileNumber: "FN-2026-0007",
    agentID: "12345",
    stateCode: "FL",
    originationSource: "EPR",
    countyCode: "011",
    policyYear: 2026,
    policyMonth: 3,
    policyDay: 12,
    productTypeAbbrTypeCode: "M",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "",
    recordTypeName: "",
    propertyTypeCode: "R",
    propertyTypeName: "",
    batchNumber: "B-2026-0312",
    liabilityAmount: 0,
    actualFee: 1500.00,
    actualRetention: 750.00,
    actualRiskRate: 750.00,
  },
  {
    uniqueIdentifier: "EX-008-e0",
    policyErrorTypeName: "Record Type Validation",
    policyErrorExceptionMessage: "Void transaction requires original policy reference.",
    policyErrorStatusTypeCode: "OPEN",
    policyErrorExceptionDate: "2026-03-23T09:00:00Z",
    policyNumber: "O-9840-0099001",
    fileNumber: "FN-2026-0008",
    agentID: "67890",
    stateCode: "NY",
    originationSource: "EPR",
    countyCode: "061",
    policyYear: 2026,
    policyMonth: 3,
    policyDay: 23,
    productTypeAbbrTypeCode: "O",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "V",
    recordTypeName: "",
    propertyTypeCode: "R",
    propertyTypeName: "",
    batchNumber: "B-2026-0323",
    liabilityAmount: 550000,
    actualFee: 0,
    actualRetention: 0,
    actualRiskRate: 0,
  },
  {
    uniqueIdentifier: "EX-009-e0",
    policyErrorTypeName: "County Validation",
    policyErrorExceptionMessage: "County code is not valid for the specified state.",
    policyErrorStatusTypeCode: "OPEN",
    policyErrorExceptionDate: "2026-03-24T10:45:00Z",
    policyNumber: "G-2200-0077889",
    fileNumber: "FN-2026-0009",
    agentID: "54321",
    stateCode: "TX",
    originationSource: "BATCH",
    countyCode: "999",
    policyYear: 2026,
    policyMonth: 3,
    policyDay: 24,
    productTypeAbbrTypeCode: "G",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "",
    recordTypeName: "",
    propertyTypeCode: "L",
    propertyTypeName: "",
    batchNumber: "B-2026-0324",
    liabilityAmount: 180000,
    actualFee: 450.00,
    actualRetention: 225.00,
    actualRiskRate: 225.00,
  },
  {
    uniqueIdentifier: "EX-010-e0",
    policyErrorTypeName: "Agent Validation",
    policyErrorExceptionMessage: "Agent license has expired for the policy effective date.",
    policyErrorStatusTypeCode: "RESOLVED",
    policyErrorExceptionDate: "2026-03-05T15:30:00Z",
    policyNumber: "L-6640-0022334",
    fileNumber: "FN-2026-0010",
    agentID: "99887",
    stateCode: "CA",
    originationSource: "EPR",
    countyCode: "073",
    policyYear: 2026,
    policyMonth: 3,
    policyDay: 5,
    productTypeAbbrTypeCode: "L",
    productTypeAbbrTypeName: "",
    transCode: "01",
    recordTypeCode: "",
    recordTypeName: "",
    propertyTypeCode: "R",
    propertyTypeName: "",
    batchNumber: "B-2026-0305",
    liabilityAmount: 625000,
    actualFee: 150.00,
    actualRetention: 75.00,
    actualRiskRate: 75.00,
  },
];
